// extracted by mini-css-extract-plugin
module.exports = {"budgeWrapper":"Table_budgeWrapper__KRPy9","budge":"Table_budge__2Syq8","tableWrapper":"Table_tableWrapper__2enjy"};